import React, { useState } from 'react';
import {
  Select,
  MenuItem,
  FormControl,
  SelectChangeEvent,
  Box,
  InputLabel,
  CircularProgress,
} from '@mui/material';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from 'react-i18next';

const LanguageSelector: React.FC = () => {
  const { currentLanguage, changeLanguage, availableLanguages, isUpdatingLanguage } = useLanguage();
  const { t } = useTranslation();

  const handleChange = (event: SelectChangeEvent<string>) => {
    const newLanguage = event.target.value;
    changeLanguage(newLanguage);
  };

  return (
      <FormControl fullWidth size="small" sx={{ mb: 3 }}>
        <InputLabel 
          id="language-select-label"
        >
          {t('settings.language')}
        </InputLabel>
        <Select
          labelId="language-select-label"
          id="language-select"
          value={currentLanguage}
          label={t('settings.language')}
          onChange={handleChange}
          size="small"
          disabled={isUpdatingLanguage}
          endAdornment={
            isUpdatingLanguage ? (
              <Box sx={{ display: 'flex', alignItems: 'center', pr: 1 }}>
                <CircularProgress size={16} />
              </Box>
            ) : null
          }
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 300,
                borderRadius: 2,
                boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
              },
            },
          }}
        >
          {availableLanguages.map((lang) => (
            <MenuItem 
              key={lang.code} 
              value={lang.code}
              sx={{
                py: 0.5,
                '&:hover': {
                  backgroundColor: 'secondary.extraLight',
                },
              }}
            >
              {lang.nativeName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

  );
};

export default LanguageSelector; 